<template>
  <!-- Begin page -->
  <div id="layout-wrapper">
    <NavigationBar/>

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Leave Report Dashboard</h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                    <li class="breadcrumb-item active">Leave & Attendance</li>
                    <li class="breadcrumb-item active">Leave Report</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <!-- end page title -->


          <!-- stats cards with tooltip information -->
          <div class="row mb-4">
            <!-- Total Leave Days Taken -->
            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0 me-3">
                      <div class="avatar-sm">
                        <span class="avatar-title bg-primary rounded-circle text-white font-size-20">
                          <i class="mdi mdi-calendar-check"></i>
                        </span>
                      </div>
                    </div>
                    <div class="flex-grow-1">
                      <h6  v-tooltip = "'Total leave days taken by all employees'">Total Leave Days</h6>
                      <h4 class="mb-0">{{ summary?.totalLeaveDays || 0 }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Approved Leaves -->
            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0 me-3">
                      <div class="avatar-sm">
                        <span class="avatar-title bg-success rounded-circle text-white font-size-20">
                          <i class="mdi mdi-check-circle"></i>
                        </span>
                      </div>
                    </div>
                    <div class="flex-grow-1">
                      <h6  v-tooltip="'Total approved leave requests'">Approved Leaves</h6>
                      <h4 class="mb-0">{{ summary?.approvedLeaves || 0 }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Pending Leaves -->
            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0 me-3">
                      <div class="avatar-sm">
                        <span class="avatar-title bg-warning rounded-circle text-white font-size-20">
                          <i class="mdi mdi-clock-outline"></i>
                        </span>
                      </div>
                    </div>
                    <div class="flex-grow-1">
                      <h6  v-tooltip="'Leave requests awaiting approval'">Pending Leaves</h6>
                      <h4 class="mb-0">{{ summary?.pendingLeaves || 0 }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Rejected Leaves -->
            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0 me-3">
                      <div class="avatar-sm">
                        <span class="avatar-title bg-danger rounded-circle text-white font-size-20">
                          <i class="mdi mdi-close-circle"></i>
                        </span>
                      </div>
                    </div>
                    <div class="flex-grow-1">
                      <h6 class="font-size-15 mb-1" v-tooltip="'Leave requests that were rejected'">Rejected Leaves</h6>
                      <h4 class="mb-0">{{ summary?.rejectedLeaves || 0 }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Row 2 of stats -->
            <!-- Sick Leave -->
            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0 me-3">
                      <div class="avatar-sm">
                        <span class="avatar-title bg-info rounded-circle text-white font-size-20">
                          <i class="mdi mdi-hospital"></i>
                        </span>
                      </div>
                    </div>
                    <div class="flex-grow-1">
                      <h6 class="font-size-15 mb-1" v-tooltip="'Total sick leave days taken'">Sick Leave</h6>
                      <h4 class="mb-0">{{ summary?.sickLeave || 0 }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Annual Leave -->
            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0 me-3">
                      <div class="avatar-sm">
                        <span class="avatar-title bg-dark rounded-circle text-white font-size-20">
                          <i class="mdi mdi-beach"></i>
                        </span>
                      </div>
                    </div>
                    <div class="flex-grow-1">
                      <h6 class="font-size-15 mb-1" v-tooltip="'Total annual leave days taken'">Annual Leave</h6>
                      <h4 class="mb-0">{{ summary?.annualLeave || 0 }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Maternity/Paternity Leave -->
            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0 me-3">
                      <div class="avatar-sm">
                        <span class="avatar-title bg-secondary rounded-circle text-white font-size-20">
                          <i class="mdi mdi-human-pregnant"></i>
                        </span>
                      </div>
                    </div>
                    <div class="flex-grow-1">
                      <h6 class="font-size-15 mb-1" v-tooltip="'Total maternity/paternity leave days'">Parental Leave</h6>
                      <h4 class="mb-0">{{ summary?.parentalLeave || 0 }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Other Leave -->
            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0 me-3">
                      <div class="avatar-sm">
                        <span class="avatar-title bg-primary rounded-circle text-white font-size-20">
                          <i class="mdi mdi-notebook"></i>
                        </span>
                      </div>
                    </div>
                    <div class="flex-grow-1">
                      <h6 class="font-size-15 mb-1" v-tooltip="'Other types of leave (study, bereavement, etc.)'">Other Leave</h6>
                      <h4 class="mb-0">{{ summary?.otherLeave || 0 }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Legend for leave status -->
          <div class="row mb-3">
            <div class="col-12">
              <div class="card">
                <div class="card-body py-2">
                  <div class="d-flex flex-wrap align-items-center">
                    <span class="me-4 mb-2 mb-md-0"><strong>Leave Status:</strong></span>
                    <div class="d-flex flex-wrap">
                      <span class="badge bg-success me-3 mb-2">Approved</span>
                      <span class="badge bg-warning me-3 mb-2">Pending</span>
                      <span class="badge bg-danger me-3 mb-2">Rejected</span>
                      <span class="badge bg-info me-3 mb-2">Cancelled</span>
                      <span class="badge bg-secondary me-3 mb-2">Expired</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Leave report table with enhancements -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white py-3 d-flex justify-content-between align-items-center flex-column flex-md-row">
                  <h5 class="card-title mb-3 mb-md-0">Leave Report</h5>

                  <div class="d-flex flex-wrap gap-2 ms-auto">
                    <!-- Export options -->
                    <div class="btn-group">
                      <button type="button" class="btn btn-sm btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="mdi mdi-export me-1"></i> Export
                      </button>
                      <ul class="dropdown-menu">
                        <!-- Excel options -->
                        <li class="dropdown-header">Excel Exports</li>
                        <li><a class="dropdown-item" href="javascript:void(0)" @click="exportToExcel">
                          <i class="mdi mdi-file-excel me-1 text-success"></i>Excel (Basic)
                        </a></li>
                        <li><a class="dropdown-item" href="javascript:void(0)" @click="exportToExcelAdvanced">
                          <i class="mdi mdi-file-excel-box me-1 text-success"></i>Excel (Advanced)
                        </a></li>

                        <!-- PDF options -->
                        <li><hr class="dropdown-divider"></li>
                        <li class="dropdown-header">PDF Exports</li>
                        <li><a class="dropdown-item" href="javascript:void(0)" @click="exportToPDF">
                          <i class="mdi mdi-file-pdf me-1 text-danger"></i>PDF
                        </a></li>

                        <!-- Other formats -->
                        <li><hr class="dropdown-divider"></li>
                        <li class="dropdown-header">Other Formats</li>
                        <li><a class="dropdown-item" href="javascript:void(0)" @click="exportToCSV">
                          <i class="mdi mdi-file-delimited me-1 text-primary"></i>CSV
                        </a></li>
                        <li><a class="dropdown-item" href="javascript:void(0)" @click="printReport">
                          <i class="mdi mdi-printer me-1 text-dark"></i>Print
                        </a></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Filter controls -->
                  <div class="row g-3 mb-4">
                    <div class="col-md-4">
                      <label class="form-label">Department</label>
                      <select v-model="selectedDepartment" class="form-select" @change="getLeaveReport">
                        <option selected="selected" value="">All Departments</option>
                        <option v-for="dept in departments" :key="dept.id" :value="dept.id">
                          {{ dept.departmentName }}
                        </option>
                      </select>
                    </div>

                    <div class="col-md-3">
                      <label class="form-label">Period</label>
                      <select v-model="selectedPeriod" class="form-select" @change="getLeaveReport">
                        <option value="current_month">Current Month</option>
                        <option value="last_month">Last Month</option>
                        <option value="last_3_months">Last 3 Months</option>
                        <option value="year_to_date">Year to Date</option>
                        <option value="custom">Custom Date Range</option>
                      </select>
                    </div>

                    <div class="col-md-5">
                      <label class="form-label">Search Employee</label>
                      <div class="position-relative">
                        <input
                            type="text"
                            v-model="searchValue"
                            class="form-control"
                            placeholder="Search by name..."
                            spellcheck="false"
                        >
                        <i class="bx bx-search-alt search-icon position-absolute top-50 end-0 translate-middle-y me-2"></i>
                      </div>
                    </div>
                  </div>

                  <!-- Custom date range (shows only when "Custom Date Range" is selected) -->
                  <div class="row mb-4" v-if="selectedPeriod === 'custom'">
                    <div class="col-md-6">
                      <label class="form-label">Start Date</label>
                      <input type="date" v-model="startDate" class="form-control" @change="getLeaveReport">
                    </div>
                    <div class="col-md-6">
                      <label class="form-label">End Date</label>
                      <input type="date" v-model="endDate" class="form-control" @change="getLeaveReport">
                    </div>
                  </div>

                  <div class="table-responsive">
                    <!-- Loading overlay with improved styling -->
                    <div v-if="loading" class="text-center p-5">
                      <div class="d-flex justify-content-center">
                        <div class="spinner-border text-primary me-3" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <div class="spinner-grow text-primary ms-3" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      </div>
                      <p class="mt-3 text-muted">Loading leave report data...</p>
                      <div class="progress mt-2" style="height: 6px;">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                             style="width: 100%;" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div>

                    <!-- Empty state when no leave records match filter -->
                    <div v-else-if="filteredLeaveRecords.length === 0" class="text-center py-5">
                      <i class="mdi mdi-calendar-blank font-size-48 text-muted"></i>
                      <h5 class="mt-3">No leave records found</h5>
                      <p class="text-muted">Try adjusting your search or filters</p>
                      <button @click="resetFilters" class="btn btn-sm btn-outline-primary mt-2">Reset Filters</button>
                    </div>

                    <!-- Leave records table -->
                    <table v-else class="table table-bordered align-middle table-hover text-nowrap" id="datatable-buttons">
                      <thead class="table-light">
                      <tr>
                        <th scope="col">Employee</th>
                        <th scope="col">Department</th>
                        <th scope="col">Leave Type</th>
                        <th scope="col">Start Date</th>
                        <th scope="col">End Date</th>
                        <th scope="col">Duration</th>
                        <th scope="col">Status</th>
                        <th scope="col">Applied On</th>
                        <th scope="col">Approved By</th>
                        <th scope="col">Reason</th>
                      </tr>
                      </thead>
                      <tbody>
                      <!-- Leave record rows with status-based styling -->
                      <tr v-for="record in paginatedLeaveRecords" :key="record.id" class="leave-record-row">
                        <td>
                          <div class="d-flex align-items-center">
                            <div v-if="record.avatar" class="avatar-xs me-2">
                              <img :src="record.avatar" class="rounded-circle" alt="avatar">
                            </div>
                            <div v-else class="avatar-xs me-2">
                              <span class="avatar-title rounded-circle bg-soft-primary text-primary">
                                {{ getInitials(record.employeeName) }}
                              </span>
                            </div>
                            <span>{{ record.employeeName }}</span>
                          </div>
                        </td>
                        <td>{{ record.department }}</td>
                        <td>
                          <span :class="getLeaveTypeClass(record.leaveType)">{{ record.leaveType }}</span>
                        </td>
                        <td>{{ formatDate(record.startDate) }}</td>
                        <td>{{ formatDate(record.endDate) }}</td>
                        <td>{{ record.duration }} day(s)</td>
                        <td>
                          <span :class="getStatusBadgeClass(record.status)">
                            {{ record.status }}
                          </span>
                        </td>
                        <td>{{ formatDate(record.appliedOn) }}</td>
                        <td>{{ record.approvedBy || '—' }}</td>
                        <td>
                          <span v-if="record.reason && record.reason.length > 30">
                            {{ record.reason.substring(0, 30) }}...
                            <i class="mdi mdi-information-outline text-info"
                               v-tooltip="record.reason"></i>
                          </span>
                          <span v-else>{{ record.reason || '—' }}</span>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!-- Pagination with record count -->
                    <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mt-4">
                      <div class="d-flex flex-wrap align-items-center mb-3 mb-md-0">
                        <div class="me-4">
                          <span>Showing <strong>{{ paginatedLeaveRecords.length }}</strong> of <strong>{{ filteredLeaveRecords.length }}</strong> leave records</span>
                        </div>
                        <div class="d-flex align-items-center">
                          <label class="me-2 mb-0">Per page:</label>
                          <select v-model.number="pageSize" class="form-select form-select-sm" style="width: 70px;" @change="onPageSizeChange">
                            <option :value="5">5</option>
                            <option :value="10">10</option>
                            <option :value="20">20</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                          </select>
                        </div>
                      </div>

                      <!-- Pagination controls -->
                      <nav v-if="totalPages > 1" aria-label="Leave report pagination">
                        <ul class="pagination pagination-rounded justify-content-center justify-content-md-end mb-0">
                          <!-- Previous page button -->
                          <li class="page-item" :class="{ disabled: currentPage <= 1 }">
                            <a class="page-link" href="javascript:void(0)" @click="changePage(currentPage - 1)" aria-label="Previous">
                              <i class="mdi mdi-chevron-left"></i>
                            </a>
                          </li>

                          <!-- Page numbers -->
                          <li v-for="page in paginationPages" :key="'page-'+page"
                              class="page-item"
                              :class="{ active: page === currentPage, disabled: page === '...' }">
                            <a v-if="page !== '...'" class="page-link" href="javascript:void(0)" @click="changePage(page)">
                              {{ page }}
                            </a>
                            <span v-else class="page-link">{{ page }}</span>
                          </li>

                          <!-- Next page button -->
                          <li class="page-item" :class="{ disabled: currentPage >= totalPages }">
                            <a class="page-link" href="javascript:void(0)" @click="changePage(currentPage + 1)" aria-label="Next">
                              <i class="mdi mdi-chevron-right"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Leave Balance section -->
          <div class="row mt-4">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white py-3">
                  <h5 class="card-title mb-0">Leave Balance Summary</h5>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-6">
                      <!-- Leave balance by department chart -->
                      <div class="leave-chart-placeholder">
                        <p class="text-muted">Visualization of leave balance by department would appear here</p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <!-- Leave balance by type chart -->
                      <div class="leave-chart-placeholder">
                        <p class="text-muted">Visualization of leave balance by type would appear here</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { authUrl, execute, getRight } from "@/api";
import NavigationBar from "@/components/Navigation.vue";

export default {
  name: "LeaveReport",
  components: {NavigationBar},

  data() {
    return {
      // Initialize the summary object with default values
      summary: {
        totalLeaveDays: 0,
        approvedLeaves: 0,
        pendingLeaves: 0,
        rejectedLeaves: 0,
        sickLeave: 0,
        annualLeave: 0,
        parentalLeave: 0,
        otherLeave: 0
      },

      // UI state
      loading: false,

      // Filter options
      selectedDepartment: '',
      selectedPeriod: 'current_month',
      searchValue: '',
      startDate: '',
      endDate: '',

      // Pagination
      currentPage: 1,
      pageSize: 10,

      // Data sources
      departments: [],
      leaveRecords: [],

      // Month names for date formatting
      months: [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ]
    };
  },

  computed: {
    filteredLeaveRecords() {
      if (!this.leaveRecords || this.leaveRecords.length === 0) {
        return [];
      }

      return this.leaveRecords.filter(record => {
        const matchesDepartment = !this.selectedDepartment ||
            record.department === this.selectedDepartment;

        const matchesSearch = !this.searchValue ||
            record.employeeName.toLowerCase().includes(this.searchValue.toLowerCase());

        return matchesDepartment && matchesSearch;
      });
    },

    paginatedLeaveRecords() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.filteredLeaveRecords.slice(startIndex, endIndex);
    },

    totalPages() {
      return Math.ceil(this.filteredLeaveRecords.length / this.pageSize);
    },

    paginationPages() {
      const pages = [];
      const maxVisiblePages = 5;

      if (this.totalPages <= maxVisiblePages) {
        // Show all pages if there are less than maxVisiblePages
        for (let i = 1; i <= this.totalPages; i++) {
          pages.push(i);
        }
      } else {
        // Always show first page
        pages.push(1);

        if (this.currentPage > 3) {
          pages.push('...');
        }

        // Pages around current page
        const startPage = Math.max(2, this.currentPage - 1);
        const endPage = Math.min(this.totalPages - 1, this.currentPage + 1);

        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }

        if (this.currentPage < this.totalPages - 2) {
          pages.push('...');
        }

        // Always show last page
        if (this.totalPages > 1) {
          pages.push(this.totalPages);
        }
      }

      return pages;
    }
  },

  mounted() {
    this.initializeDates();
    this.fetchDepartments();
    this.getLeaveReport();
  },

  methods: {
    initializeDates() {
      const now = new Date();
      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

      this.startDate = this.formatDateForInput(startOfMonth);
      this.endDate = this.formatDateForInput(endOfMonth);
    },

    formatDateForInput(date) {
      return date.toISOString().split('T')[0];
    },

    fetchDepartments() {
      this.loading = true;
      const data = new FormData();
      data.append("function", "getDepartments");
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              if (res.data.data && Array.isArray(res.data.data.departments)) {
                this.departments = res.data.data.departments;
              } else {
                console.log("No departments data found or incorrect data format");
                this.departments = [];
              }
            } else {
              console.error("Error fetching departments:", res.data.message || "Unknown error");
              // Check if toast plugin exists before using it
              if (this.$toast) {
                this.$toast.error("Failed to load departments: " + (res.data.message || "Unknown error"));
              }
            }
            this.loading = false;
          })
          .catch((e) => {
            const errorMessage = e && e.message ? e.message : "Unknown error";
            console.error("API error when fetching departments:", errorMessage);
            // Check if toast plugin exists before using it
            if (this.$toast) {
              this.$toast.error("Network error: " + errorMessage);
            }
            this.loading = false;
          });
    },

    getLeaveReport() {
      this.loading = true;

      // Update date range based on selected period
      this.updateDateRangeFromPeriod();

      // Prepare request data
      const data = new FormData();
      data.append("function", "getLeaveRequests");
      data.append("startDate", this.startDate);
      data.append("endDate", this.endDate);

      // Add department filter if selected
      if (this.selectedDepartment) {
        data.append("departmentId", this.selectedDepartment);
      }

      // Make API call
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              if (res.data.data && Array.isArray(res.data.data.leaveRequests)) {
                // Transform API response to match our data structure
                this.leaveRecords = res.data.data.leaveRequests.map(item => ({
                  id: item.id,
                  employeeName: item.names,
                  department: this.getDepartmentNameById(item.departmentId) || '-', // Get department name if available
                  leaveType: item.leaveTypeName,
                  startDate: item.startDate.split(' ')[0], // Extract date part
                  endDate: item.endDate.split(' ')[0], // Extract date part
                  duration: parseFloat(item.totalDays),
                  status: item.status,
                  appliedOn: item.createdAt.split(' ')[0], // Extract date part
                  approvedBy: item.approvedBy || null,
                  reason: item.reason || '-'
                }));

                // Update summary metrics if available
                if (res.data.data.metrics) {
                  this.summary = {
                    totalLeaveDays: this.calculateTotalLeaveDays(this.leaveRecords),
                    approvedLeaves: parseInt(res.data.data.metrics.approvedRequests) || 0,
                    pendingLeaves: parseInt(res.data.data.metrics.pendingRequests) || 0,
                    rejectedLeaves: parseInt(res.data.data.metrics.rejectedRequests) || 0,
                    // We'll calculate these in updateSummary() based on the leaveRecords
                    sickLeave: 0,
                    annualLeave: 0,
                    parentalLeave: 0,
                    otherLeave: 0
                  };
                }

                // Calculate leave type summary
                this.updateSummary();
              } else {
                console.log("No leave requests found or incorrect data format");
                this.leaveRecords = [];
                this.resetSummary();
              }
            } else {
              console.error("Error fetching leave requests:", res.data.message || "Unknown error");
              if (this.$toast) {
                this.$toast.error("Failed to load leave report: " + (res.data.message || "Unknown error"));
              }
              this.leaveRecords = [];
              this.resetSummary();
            }
            this.loading = false;
          })
          .catch((e) => {
            const errorMessage = e && e.message ? e.message : "Unknown error";
            console.error("API error when fetching leave requests:", errorMessage);
            if (this.$toast) {
              this.$toast.error("Network error: " + errorMessage);
            }
            this.leaveRecords = [];
            this.resetSummary();
            this.loading = false;
          });
    },

    // Helper function to get department name by ID
    getDepartmentNameById(departmentId) {
      if (!departmentId) return null;
      const department = this.departments.find(dept => dept.id === departmentId);
      return department ? department.departmentName : null;
    },

    // Helper function to calculate total leave days
    calculateTotalLeaveDays(records) {
      return records.reduce((total, record) => {
        return total + (parseFloat(record.duration) || 0);
      }, 0);
    },

    // Reset summary to default values
    resetSummary() {
      this.summary = {
        totalLeaveDays: 0,
        approvedLeaves: 0,
        pendingLeaves: 0,
        rejectedLeaves: 0,
        sickLeave: 0,
        annualLeave: 0,
        parentalLeave: 0,
        otherLeave: 0
      };
    },

    updateDateRangeFromPeriod() {
      const now = new Date();
      let startDate, endDate;

      switch(this.selectedPeriod) {
        case 'current_month':
          startDate = new Date(now.getFullYear(), now.getMonth(), 1);
          endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
          break;

        case 'last_month':
          startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
          endDate = new Date(now.getFullYear(), now.getMonth(), 0);
          break;

        case 'last_3_months':
          startDate = new Date(now.getFullYear(), now.getMonth() - 3, 1);
          endDate = new Date();
          break;

        case 'year_to_date':
          startDate = new Date(now.getFullYear(), 0, 1);
          endDate = new Date();
          break;

        case 'custom':
          // Use the custom date range as is
          return;
      }

      this.startDate = this.formatDateForInput(startDate);
      this.endDate = this.formatDateForInput(endDate);
    },

    updateSummary() {
      // Calculate leave type statistics from leave records
      let sickLeave = 0;
      let annualLeave = 0;
      let parentalLeave = 0;
      let otherLeave = 0;

      this.leaveRecords.forEach(record => {
        // Count by type
        if (record.leaveType === 'Sick Leave') sickLeave += record.duration;
        else if (record.leaveType === 'Annual Leave') annualLeave += record.duration;
        else if (record.leaveType === 'Parental Leave') parentalLeave += record.duration;
        else otherLeave += record.duration;
      });

      // Update leave type counts
      this.summary.sickLeave = sickLeave;
      this.summary.annualLeave = annualLeave;
      this.summary.parentalLeave = parentalLeave;
      this.summary.otherLeave = otherLeave;
    },

    resetFilters() {
      this.selectedDepartment = '';
      this.searchValue = '';
      this.selectedPeriod = 'current_month';
      this.updateDateRangeFromPeriod();
      this.getLeaveReport();
      this.currentPage = 1;
    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },

    onPageSizeChange() {
      this.currentPage = 1; // Reset to first page when changing page size
    },

    formatDate(dateString) {
      if (!dateString) return '';

      const date = new Date(dateString);
      return `${date.getDate()} ${this.months[date.getMonth()]} ${date.getFullYear()}`;
    },

    getInitials(name) {
      if (!name) return '';

      return name
          .split(' ')
          .map(part => part.charAt(0))
          .join('')
          .toUpperCase()
          .substring(0, 2);
    },

    getStatusBadgeClass(status) {
      switch (status) {
        case 'Approved': return 'badge bg-success';
        case 'Pending': return 'badge bg-warning';
        case 'Rejected': return 'badge bg-danger';
        case 'Cancelled': return 'badge bg-info';
        default: return 'badge bg-secondary';
      }
    },

    getLeaveTypeClass(type) {
      switch (type) {
        case 'Sick Leave': return 'text-info';
        case 'Annual Leave': return 'text-dark';
        case 'Parental Leave': return 'text-secondary';
        default: return 'text-primary';
      }
    },

    exportToExcel() {
      alert('Export to Excel functionality would be implemented here');
    },

    exportToExcelAdvanced() {
      alert('Export to Advanced Excel functionality would be implemented here');
    },

    exportToPDF() {
      alert('Export to PDF functionality would be implemented here');
    },

    exportToCSV() {
      alert('Export to CSV functionality would be implemented here');
    },

    printReport() {
      window.print();
    }
  }
};
</script>
